import React, { ReactNode } from "react";
import { CpBadge } from "@components";
import { CpSelect } from "../cp-select/cp-select.component";
import { BadgeItemSingle } from "./badge-item-single.component";
import type { Placement } from "@floating-ui/react";

type BadgeOption = Record<string, any> & {
  name: string;
};

type CpSelectBadgeProps = {
  appendTo?: HTMLElement | string;
  options: BadgeOption[];
  value?: BadgeOption;
  onChange: (value: BadgeOption | undefined) => void;
  emptyCase?: string;
  disabled?: boolean;
  contentWidth?: string | number;
  position?: Placement;
  triggerIsBlock?: boolean;
  renderTrigger?: (props: { toggle: () => void }) => ReactNode;
  hideSelected?: boolean;
};

export function CpSelectBadge({
  appendTo,
  options,
  value,
  onChange,
  emptyCase = "",
  disabled,
  contentWidth,
  position,
  triggerIsBlock,
  renderTrigger,
  hideSelected = false, // added with renderTrigger for task dashboard right click change priority (consider removing once a solution better than dropdown in dropdown is enacted)
}: CpSelectBadgeProps) {
  // Validate emptyCase
  if (emptyCase && !options.find((o) => o.name === emptyCase)) {
    console.error(
      `The provided emptyCase '${emptyCase}' does not match any names in the provided options. Please include an option with name: '${emptyCase}'.`,
    );
  }

  // Validate value
  if (value && !options.some((o) => o.name === value.name)) {
    console.error(
      `The value '${value.name}' provided to <CpSelectBadge /> is not found in 'options'.`,
    );
  }

  const defaultTrigger = ({ toggle }: { toggle: () => void }) => (
    <CpBadge onClick={toggle}>{value?.name || emptyCase}</CpBadge>
  );

  return (
    // @ts-expect-error - CpSelect is not fully typed yet
    <CpSelect
      appendTo={appendTo}
      contentWidth={
        typeof contentWidth === "number" ? String(contentWidth) : contentWidth
      }
      data={options}
      disabled={disabled}
      position={position}
      onChange={onChange}
      renderItem={BadgeItemSingle}
      renderTrigger={renderTrigger || defaultTrigger}
      triggerIsBlock={triggerIsBlock}
      // searchFilter={CpSelect.filterAlpha(search)}
      // searchHideEmptyState
      //  searchOnChange={setSearch}
      //  searchValue={search}
      value={
        value || (!hideSelected && options.find((o) => o.name === emptyCase))
      }
      transformData={(item: BadgeOption) => ({
        id: item.name,
        name: item.name,
      })}
    />
  );
}
